module.exports = __webpack_public_path__ + "img/logo-white-no-label--new.bdbff6b0.png";